import React from 'react';
import { DrawerHeader, ModalProps } from '@features/Modal';
import { Steps } from '@features/Steps';
import { useErrorNotify } from '@features/useErrorNotify';
import { IServiceTransferReportDto } from '@shared/api';
import { useAsyncData } from '@shared/react';
import { getCurrDayById, getPrevDayById } from '@widgets/ISOReportsTable/api';
import { IsoReportType } from '@widgets/ISOReportsTable/lib';
import { ISOReportTabs } from './components';
import './ISOReportsDrawer.scss';

interface IISOReportModalProps extends ModalProps {
    isoReport: IServiceTransferReportDto;
    type: IsoReportType;
}

export const ISOReportsDrawer: React.FC<IISOReportModalProps> = (props) => {
    const { isoReport, type } = props;

    const {
        data: isoReportDetail,
        loading: isoReportDetailLoading,
        error: isoReportDetailError,
        handleRefresh: isoReportDetailRefresh,
    } = useAsyncData(
        async () => {
            const query = { id: isoReport.id };
            return type === 'current' ? await getCurrDayById(query) : await getPrevDayById(query);
        },
        null,
        [type],
    );
    useErrorNotify(isoReportDetailError, 'Payment Request');

    const targetData =
        isoReportDetail?.document?.bkToCstmrAcctRpt?.rpt || isoReportDetail?.document.bkToCstmrStmt?.stmt;

    const steps = targetData?.map((item) => {
        return {
            title: item.acct.id.item.id,
            step: (
                <ISOReportTabs
                    key={item.id}
                    data={item}
                />
            ),
        };
    });

    return (
        <div className='widget-iso-report-drawer'>
            <DrawerHeader headerTitle={`ISO Report: ${isoReport.id}`} />
            {steps?.length && (
                <Steps
                    footerClassName='widget-iso-report-drawer__footer'
                    headerClassName='widget-iso-report-drawer__header'
                    className='widget-iso-report-drawer__steps'
                    headerStepLabelClassName='widget-iso-report-drawer__header-step-label'
                    headerStepLineClassName='widget-iso-report-drawer__header-step-line'
                    titles={steps.map((item) => item.title)}
                    footerVisible={false}
                >
                    {steps.map((item) => item.step)}
                </Steps>
            )}
        </div>
    );
};
